// Internal modules
import styled from '@emotion/styled';

export const OptionalAccountFieldset = styled.fieldset<{
  shouldAddMargin?: boolean;
}>`
  margin-top: 6px;

  padding-left: 35px;

  > div {
    margin-bottom: ${({ shouldAddMargin }) => (shouldAddMargin ? '12px' : '0')};
  }
`;

export const OptionalAccountOption = styled.div`
  margin-bottom: 18px;

  &:last-of-type {
    margin-bottom: 32px;
  }
`;

export const SepaContainer = styled.div`
  padding-top: 8px;
`;
